import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, LOCALE_ID } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';

import { KPErrorHandler } from '@kp/common/services';
import { baseUrlInterceptor } from '@kp/core/interceptors';
import { VALIDATION_MESSAGES } from '@kp/forms/tokens';
import { TiiaAuthService } from '@kp/tiia-services';

import { AuthInterceptor } from '../interceptors/auth.interceptor';
import { APP_ROUTES } from '../routes';

import type { ApplicationConfig } from '@angular/core';

export const appConfig: ApplicationConfig = {
  providers: [
    TiiaAuthService,
    { provide: ErrorHandler, useClass: KPErrorHandler },
    {
      multi: true,
      provide: VALIDATION_MESSAGES,
      useValue: {
        required: (): string => 'Toto políčko je povinné',
      },
    },
    {
      provide: LOCALE_ID,
      useValue: 'cz-CZ',
    },
    provideRouter(
      APP_ROUTES,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),
    provideHttpClient(withInterceptors([baseUrlInterceptor, AuthInterceptor])),
  ],
};
